export enum BudgetDetailTransactionType {
Approval,
Adjustment,
Request,
Invoicing,
ReleaseRemainingAmount,
Cancelation,
Order,
Payment,
Issue,
}
